import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLazyQuery } from '@apollo/client'
import { MAILS_TO_FORWARD_MINI, MailsToForwardResult, MailsToForwardVariables } from 'graphql/mails/queries'
import { displayErrors } from 'globals/graphql'
import { Link } from 'react-router-dom'
import { MailIcon } from 'components/Icons'
import { Subtitle } from 'pages/Home/styles'
import { DayForwardings, ForwardingCard, DayForwardingsHeader } from './styles'
import Loader from 'components/Loader'

const DaysForwardingTile = () => {
  const { t } = useTranslation()

  const [fetchMailsToForward, { loading, data }] = useLazyQuery<MailsToForwardResult, MailsToForwardVariables>(
      MAILS_TO_FORWARD_MINI, { ...displayErrors, fetchPolicy: 'no-cache' }
  )

  useEffect(() => {
    fetchMailsToForward({ variables: { page: 1, pageLength: 1 } })
  }, [])

  return (
    <DayForwardings>
      <DayForwardingsHeader>
        <Subtitle smallMargin>{t('home.forwardings.subtitle')}</Subtitle>
      </DayForwardingsHeader>

      <ForwardingCard>
        { loading && <Loader /> }
        { !loading &&
          <>
            <MailIcon />
            <b>{data?.userMailsToForward?.pagination?.totalItemsCount}</b>&nbsp;
            <span>{t('home.forwardings.mails-to-treat')}</span>
            <br />
            <Link to={'/mails'}>{t('home.forwardings.view-mails')}</Link>
          </>
        }
      </ForwardingCard>
    </DayForwardings>
  )
}

export default DaysForwardingTile
